
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eYFK8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ffbe72148ca5e601$export$2e2bcd8739ae039);

var $53Xu4 = parcelRequire("53Xu4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kGj4V = parcelRequire("kGj4V");

var $eQFAG = parcelRequire("eQFAG");
const $ffbe72148ca5e601$var$UserSegmentationRedirectEntry = ({ queries: { userSegQueryRef: userSegQueryRef } })=>{
    /**
   * ⚠️ This is just temporary redirect logic used for testing
   * while awaiting the implementation of a new query
   */ const queryRef = (0, $j4oe4.usePreloadedQuery)((0, $53Xu4.default), userSegQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "globalRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eQFAG.default), {
        queryRef: queryRef
    }));
};
var $ffbe72148ca5e601$export$2e2bcd8739ae039 = $ffbe72148ca5e601$var$UserSegmentationRedirectEntry;

});
parcelRegister("53Xu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $125bf17dd79208ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42bb0577a4d8fb5d5c0be223d981b9ef>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134

var $37Ewn = parcelRequire("37Ewn");
const $125bf17dd79208ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserSegmentationRedirectEntryQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "UserSegmentationRedirect_fragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserSegmentationRedirectEntryQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "accountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserSegRedirectAdvice",
                    "kind": "LinkedField",
                    "name": "jira_userSegRedirectAdvice",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "redirect"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
            "metadata": {},
            "name": "UserSegmentationRedirectEntryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$125bf17dd79208ac$var$node.hash = "84997e1dc4b2632cf44e7fc7fd4fc910";
(0, $37Ewn.PreloadableQueryRegistry).set($125bf17dd79208ac$var$node.params.id, $125bf17dd79208ac$var$node);
var $125bf17dd79208ac$export$2e2bcd8739ae039 = $125bf17dd79208ac$var$node;

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("eQFAG", function(module, exports) {
$parcel$export(module.exports, "default", () => $02f24fb42cac73c8$export$2e2bcd8739ae039);

var $gAQI7 = parcelRequire("gAQI7");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gRw8I = parcelRequire("gRw8I");

var $7fTjp = parcelRequire("7fTjp");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $d4YDC = parcelRequire("d4YDC");
const $02f24fb42cac73c8$var$UserSegmentationRedirect = ({ queryRef: queryRef })=>{
    (0, $gRw8I.di)(globalThis);
    /**
   * ⚠️ This is just temporary redirect logic used for testing
   * while awaiting the implementation of a new query
   */ const data = (0, $j4oe4.useFragment)((0, $gAQI7.default), queryRef);
    const currentUrl = globalThis.location.href;
    const userHasVisitedUserSeg = (0, $d4YDC.hasVisitedUserSeg)(currentUrl);
    const shouldRedirect = !userHasVisitedUserSeg && !!data.jira_userSegRedirectAdvice?.redirect;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('disable_analytics_error_user_seg')) {
            if (shouldRedirect) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'route redirected', {
                destination: 'user-segmentation'
            });
        }
    }, [
        createAnalyticsEvent,
        shouldRedirect
    ]);
    if ((0, $9790b8dfe6f31c81$export$19d68f5aa485d903) && shouldRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fTjp.ScreenRedirect), {
        to: `/jira/get-started?continueUrl=${encodeURIComponent(currentUrl)}`,
        persistSearchParams: false
    });
    return null;
};
var $02f24fb42cac73c8$export$2e2bcd8739ae039 = $02f24fb42cac73c8$var$UserSegmentationRedirect;

});
parcelRegister("gAQI7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9c5f63f3c0ca032$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee2c89d847748868ed6cb4650c2b9039>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a9c5f63f3c0ca032$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "accountId"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "UserSegmentationRedirect_fragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraUserSegRedirectAdvice",
            "kind": "LinkedField",
            "name": "jira_userSegRedirectAdvice",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "redirect"
                }
            ]
        }
    ],
    "type": "Query"
};
$a9c5f63f3c0ca032$var$node.hash = "e97a1130d45ff78da3f6db7ae68eba45";
var $a9c5f63f3c0ca032$export$2e2bcd8739ae039 = $a9c5f63f3c0ca032$var$node;

});

parcelRegister("7fTjp", function(module, exports) {
$parcel$export(module.exports, "ScreenRedirect", () => $d4a25a2e90068241$export$fdd3e60cd227c2f7);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $3lhVL = parcelRequire("3lhVL");

var $2mHfh = parcelRequire("2mHfh");
var $gCY1z = parcelRequire("gCY1z");
const $d4a25a2e90068241$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $gCY1z.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $3lhVL.useSpaStateTransition)();
    const eventRef = (0, $eJOHy.useRef)(createAnalyticsEvent({}));
    (0, $eJOHy.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $kRgKj.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

parcelRegister("d4YDC", function(module, exports) {
$parcel$export(module.exports, "hasVisitedUserSeg", () => $6f158b01167d8db1$export$fef78b3b53362f66);

const $6f158b01167d8db1$export$fef78b3b53362f66 = (url)=>{
    // URLSearchParams#has is misbehaving on the server
    // which is why we're asserting against the URL string
    return url.includes(`${(0, $24140b7c2bc71173$export$9218517319690531)}=true`);
};

});
const $24140b7c2bc71173$export$83c8d7110915321e = 'jiraUserSegmentationScreen';
const $24140b7c2bc71173$export$9218517319690531 = 'visitedUserSeg';





//# sourceMappingURL=async-user-seg-redirect-entrypoint.7acb7e18.js.map
